import { buildUserContextKey, getUserContextRevision, useUserContext } from '../composables/userContext.js';

let pending = null;
const currentIdentity = () => buildUserContextKey(useUserContext().userContext.value);

export function prefetchBots(load, identity) {
    if (!identity || identity !== currentIdentity()) return;
    if (pending?.identity === identity && pending.revision === getUserContextRevision() && Date.now() - pending.startedAt < 15000) return;
    const request = { identity, revision: getUserContextRevision(), startedAt: Date.now(), promise: null, consumed: false, settled: false };
    request.promise = load().catch(error => {
        if (pending === request) pending = null;
        throw error;
    }).finally(() => {
        request.settled = true;
        if (pending === request && request.consumed) pending = null;
    });
    pending = request;
    void request.promise.catch(() => {});
}

export function currentBotIdentity() {
    return currentIdentity();
}

export function consumePrefetchedBots() {
    const request = pending;
    if (!request || request.identity !== currentIdentity() || request.revision !== getUserContextRevision() || Date.now() - request.startedAt >= 15000) return null;
    request.consumed = true;
    if (request.settled) pending = null;
    return request.promise.then(value => {
        if (request.identity !== currentIdentity() || request.revision !== getUserContextRevision()) throw new DOMException('User context changed', 'AbortError');
        return value;
    });
}
